import React from "react";
import { TabelaDeCotacaoConcurso } from "./index";

export default function KenoCotacoes({ tipoCotacoes, nomeJogo }) {
  return (
    <div class="container-cotacoes">
      <h1>Premiações!</h1>
      <h2>Quanto posso ganhar?</h2>
      <p>
        No <strong className="capitalize">{nomeJogo}</strong>, a premiação é
        baseada na quantidade de dezenas que foram acertadas durante o sorteio.
        Desta forma, quanto mais dezenas você acertar, maior será a sua
        premiação!
      </p>
      {nomeJogo === "keno divertidu" && (
        <p>Keno Divertidu tem um valor fixo de R$: 2,00.</p>
      )}
      <p>
        <strong>Segue cotação baseado em R$: 1,00.</strong>
      </p>
      <TabelaDeCotacaoConcurso acertosValor={tipoCotacoes.acertosValor} />
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/newDesign/components/cotacoes/keno.jsx